module.exports = __webpack_public_path__ + "img/place_holder.c6278523.jpg";